/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { refreshPage } from '../../store/feature/authSlice';
import {
  clearListingDetails,
  setListingDetailsData,
} from '../../store/feature/listingSlice';
import {
  setGeneralConfig,
  setListingConfig,
} from '../../store/feature/configsSlice';
import { listing_details_page } from '../../tradly.config';
import { TYPE_CONSTANT } from '../../constant/Web_constant';
import {
  set_domain_name,
  encryptDataWithAES,
  decryptDataWithAES,
  set_host_name,
  get_pk_key_from_cookie,
  get_domain_details_from_cookie,
} from '../../constant/sdk_set';
import tradly from 'tradly';
import {
  all_integrations_data,
  getProductStructureData,
  metadata,
  structuredData,
} from '../../constant/Metadata';
import Head from 'next/head';
import { seo_text } from '../../constant/static_text';
import SEO_Head from '../../constant/SEO_Head';
import {
  set_root_configs,
  ssr_configs_set,
} from '../../constant/Root_configs_set';
import { Common_ssr_functions } from '../../constant/SSR_functions';
import { useRouter } from 'next/router';
import { ssr_translation_functions } from '../../constant/Translation/SSR_translation';
import { Menubar_text } from '../../constant/Translation/Heading';
import { General_text } from '../../constant/Translation/General';
import { Account_text } from '../../constant/Translation/Account';
import { Notification_text } from '../../constant/Translation/Notification';
import { Listing_text } from '../../constant/Translation/Listing';
import { set_root_translation } from '../../constant/Translation/translation_set';
import { push_data_layer } from '../../constant/GTMDatalayer';
import { getCookie, setCookie } from 'cookies-next';
import { clearNegotiateState } from '../../store/feature/negotiate/negotiateSlice';
import { Review_text } from '../../constant/Translation/Review';
import { Payment_text } from '../../constant/Translation/Payment';
import { Checkout_text } from '../../constant/Translation/Cart_text';
import { Shipping_text } from '../../constant/Translation/Shipping_text';
import { Address_text } from '../../constant/Translation/Address';

const Details = ({
  listing_details,
  configs_list_data,
  client_translations,
}) => {
  const router = useRouter();
  const dispatch = useDispatch();

  // Configs decryption
  const [configs_list, setConfigsList] = useState(
    JSON.parse(decryptDataWithAES(configs_list_data))
  );

  useEffect(() => {
    // Decrypt the data when the prop value changes
    const decryptedValue = JSON.parse(decryptDataWithAES(configs_list_data));
    setConfigsList(decryptedValue);
  }, [configs_list_data]);

  //
  useEffect(() => {
    return () => {
      // reset state when component unmounts
      dispatch(clearListingDetails());
      dispatch(clearNegotiateState());
    };
  }, []);

  // refresh action call
  useEffect(() => {
    window.addEventListener('focus', () => {
      dispatch(refreshPage({}));
    });
    dispatch(refreshPage({}));
  }, []);

  useEffect(() => {
    if (listing_details && Object.keys(listing_details)?.length > 0) {
      dispatch(
        setListingDetailsData(
          Object.keys(listing_details)?.length > 0 ? listing_details : undefined
        )
      );
    } else {
      router.push('/not-found');
    }
    if (configs_list) {
      dispatch(setGeneralConfig({ general_configs: configs_list?.general }));
      dispatch(setListingConfig({ listing_configs: configs_list?.listings }));
    }
  }, [listing_details, configs_list]);

  // seo title
  const seoTitle = (text, listing_title) => {
    if (text) {
      const check = text.includes('{listing_title}');
      if (check) {
        return text.replace('{listing_title}', listing_title);
      }
      return text;
    } else {
      return listing_title;
    }
  };

  // Seo description
  const seoDescription = (text, desc) => {
    if (text) {
      const check = text.includes('{listing_description}');
      if (check) {
        return text.replace('{listing_description}', desc);
      }
      return text;
    } else {
      return desc;
    }
  };

  metadata.title = configs_list?.seo?.meta_listing_title
    ? seoTitle(configs_list?.seo?.meta_listing_title, listing_details?.title)
    : listing_details?.meta_title
    ? listing_details?.meta_title
    : listing_details?.title;

  metadata.meta_description = configs_list?.seo?.meta_listing_description
    ? seoDescription(
        configs_list?.seo?.meta_listing_description,
        listing_details?.description
      )
    : listing_details?.meta_description
    ? listing_details?.meta_description
    : listing_details?.description;
  metadata.image =
    listing_details?.images?.length > 0
      ? listing_details?.images[0]
      : configs_list?.general?.web_logo;
  all_integrations_data.google_tag_manager =
    configs_list?.integrations?.google_tag_manager;

  all_integrations_data.facebook_pixel =
    configs_list?.integrations?.facebook_pixel;
  structuredData.json_data = getProductStructureData(
    listing_details,
    window && window.location.href
  );
  metadata.url = typeof window !== 'undefined' && window.location.href;
  //
  if (typeof window !== 'undefined') {
    set_root_configs({
      is_draft: router?.query?.draft,
      all_configs: configs_list,
    });

    // translation set
    set_root_translation({
      translation_values: client_translations,
      group_names: [
        'more',
        'general',
        'storelist',
        'notification',
        'product',
        'productlist',
        'productschedule',
        'producttime',
        'addreview',
        'payment',
        'payments',
        'cart',
        'shipping',
        'shipment',
        'address',
      ],
      translation_file: [
        Menubar_text,
        General_text,
        Account_text,
        Notification_text,
        Listing_text,
        Review_text,
        Payment_text,
        Checkout_text,
        Shipping_text,
        Address_text,
      ],
    });
  }

  //GTM page view
  useEffect(() => {
    if (
      listing_details !== undefined ||
      listing_details !== null ||
      Object.keys(listing_details).length !== 0
    ) {
      push_data_layer({
        event: 'listing_view',
        data: {
          name: listing_details?.title,
          slug: listing_details?.slug,
          price: listing_details?.offer_price?.amount,
          stock: listing_details?.stock,
          category: {
            id: listing_details?.categories?.[0]?.id,
            name: listing_details?.categories?.[0]?.name,
          },
          images: listing_details?.images,
          url: window.location.href,
        },
      });
    }
  }, [router.asPath]);

  return (
    <>
      <SEO_Head />
      {listing_details_page()}
    </>
  );
};

export default Details;

// Server side function
export async function getServerSideProps({ params, req, res, query }) {
  var host = set_domain_name(req);
  const auth_key = req.cookies[`${set_host_name(req)}_auth_key`];
  let default_language =
    req.cookies[`${set_host_name(req)}_default_language`] ?? undefined;
  const currency = req.cookies[`${set_host_name(req)}_default_currency`];

  const { id, slug } = query;

  // Main sdk set
  const sdk_set = await tradly.set_sdk
    .config({
      domain: host,
      env: process.env.ENVIRONMENT,
      pk_key: get_pk_key_from_cookie({ req: req, res: res }),
      domain_details: get_domain_details_from_cookie({ req: req, res: res }),
    })
    .then((res) => {
      if (res?.status !== true) {
        throw new Error('Have problme');
      } else {
        return { status: true, data: { message: 'Tenant found successfully' } };
      }
    })
    .catch((err) => {
      return err;
    });

  // tenant_languages_promise

  let tenant_languages_promise;
  if (default_language == undefined) {
    tenant_languages_promise = await tradly.app
      .getTenantLanguages({
        authKey: auth_key ? auth_key : '',
        currency: currency,
      })
      .then((lng_res) => {
        const default_language_select = lng_res.data.languages.filter(
          (item) => item.default === true
        )[0];
        default_language = default_language_select.code;
        setCookie(
          `${set_host_name(req)}_default_language`,
          default_language_select.code,
          {
            req,
            res,
          }
        );
        setCookie(
          `${set_host_name(req)}_direction`,
          default_language_select?.rtl ? 'rtl' : 'ltr',
          {
            req,
            res,
          }
        );
        TYPE_CONSTANT.DIR = default_language?.rtl ? 'rtl' : 'ltr';
        return lng_res;
      })
      .catch((err) => {
        return err;
      });
  } else {
    TYPE_CONSTANT.DIR = getCookie(`${set_host_name(req)}_direction`, {
      req,
      res,
    });
    tenant_languages_promise = {};
  }
  // Listing Details
  let listing_details_promise;
  const reg = new RegExp('^[0-9]*$');
  if (reg.test(slug.split('-')[0]) && id == 'true') {
    listing_details_promise = tradly.app.getListingDetail({
      id: slug.split('-')[0],
      slug: undefined,
      authKey: auth_key ? auth_key : '',
      currency: currency,
      language: default_language,
    });
  } else {
    listing_details_promise = tradly.app
      .getListingDetail({
        id: undefined,
        slug: slug,
        authKey: auth_key ? auth_key : '',
        currency: currency,
        language: default_language,
      })
      .then(async (resp) => {
        if (resp.error) {
          return await tradly.app.getListingDetail({
            id: slug.split('-')[0],
            slug: undefined,
            authKey: auth_key ? auth_key : '',
            currency: currency,
            language: default_language,
          });
        }
        return resp;
      });
  }

  // all_configs_promise
  const all_configs_promise = tradly.app.getGroupedConfigList({
    paramBody: TYPE_CONSTANT.CONFIGS_GROUPS,
    authKey: auth_key ? auth_key : '',
    currency: currency,
    language: default_language,
  });

  // client_translations_promise
  const client_translations_promise =
    tradly.app.clientTranslationsValuesByGroup({
      bodyParam: {
        language: default_language,
        group: [
          'more',
          'general',
          'storelist',
          'notification',
          'product',
          'productlist',
          'productschedule',
          'producttime',
          'addreview',

          'payment',
          'payments',
          'cart',
          'shipping',
          'shipment',
          'address',
        ].toString(),
      },
      authKey: auth_key ? auth_key : '',
      currency: currency,
    });

  //  Destructure variable
  let listing_details;
  let configs_list;
  let client_translations;

  try {
    // Promiss all
    let all_response = await Promise.all([
      sdk_set,
      tenant_languages_promise,
      listing_details_promise,
      all_configs_promise,
      client_translations_promise,
    ]);

    // response values destructure
    listing_details = all_response[2]?.data?.listing ?? {};
    configs_list = all_response[3]?.data?.configs ?? {};
    client_translations =
      all_response[4]?.data?.grouped_client_translation_values ?? {};

    //
    ssr_configs_set({
      is_draft: query.draft,
      all_configs: all_response[1]?.data?.configs,
    });

    // seo title
    const seoTitle = (text, listing_title) => {
      if (text) {
        const check = text.includes('{listing_title}');
        if (check) {
          return text.replace('{listing_title}', listing_title);
        }
        return text;
      } else {
        return listing_title;
      }
    };

    // Seo description
    const seoDescription = (text, desc) => {
      if (text) {
        const check = text.includes('{listing_description}');
        if (check) {
          return text.replace('{listing_description}', desc);
        }
        return text;
      } else {
        return desc;
      }
    };

    // translation set
    set_root_translation({
      translation_values: client_translations,
      group_names: [
        'more',
        'general',
        'storelist',
        'notification',
        'product',
        'productlist',
        'productschedule',
        'producttime',
        'addreview',

        'payment',
        'payments',
        'cart',
        'shipping',
        'shipment',
        'address',
      ],
      translation_file: [
        Menubar_text,
        General_text,
        Account_text,
        Notification_text,
        Listing_text,
        Review_text,
        Payment_text,
        Checkout_text,
        Shipping_text,
        Address_text,
      ],
    });

    metadata.title = configs_list?.seo?.meta_listing_title
      ? seoTitle(configs_list?.seo?.meta_listing_title, listing_details?.title)
      : listing_details?.meta_title
      ? listing_details?.meta_title
      : listing_details?.title;

    metadata.meta_description = configs_list?.seo?.meta_listing_description
      ? seoDescription(
          configs_list?.seo?.meta_listing_description,
          listing_details?.description
        )
      : listing_details?.meta_description
      ? listing_details?.meta_description
      : listing_details?.description;
    metadata.url = req?.headers?.host + req?.url;
    metadata.image =
      listing_details?.images?.length > 0
        ? listing_details?.images[0]
        : configs_list?.general?.web_logo;
    all_integrations_data.google_tag_manager =
      configs_list?.integrations?.google_tag_manager;
    structuredData.json_data = getProductStructureData(
      listing_details,
      req?.headers?.host + req?.url
    );
  } catch (error) {
    listing_details = {};
    configs_list = {};
    client_translations = {};
  }

  return {
    props: {
      listing_details,
      configs_list_data: encryptDataWithAES(JSON.stringify(configs_list)),
      client_translations,
    },
  };
}
